import { defineAsyncComponent } from "vue";

export default {
  forms: {
    edit: {
      panel: {
        width: "85%",
        height: "100%",
      },
      component: defineAsyncComponent(() => import("./forms/Edit.vue")),
    },
    list: {
      component: defineAsyncComponent(() => import("./forms/List.vue")),
    },
    select: {
      config: {
        fields: {
          name: {},
          created_at: {},
          updated_at: {},
        },
      },
    },
  },
};
